<template>

<div id="slide09" class="section section-white">

  <div class="one-fourth-block one-fourth-block-no-last">

    <div class="image-div">

      <Qimage name="madrid.jpg"/>

      <Qimage name="simo.jpg"/>

    </div>

    <Small :text="$t('home.slide09.text1')"/>

  </div>

  <div class="one-fourth-block one-fourth-block-no-last one-fourth-block-no-first">

    <div class="image-div">
      <Qimage name="seklab.jpg"/>
    </div>

    <Small :text="$t('home.slide09.text2')"/>

  </div>

  <div class="one-fourth-block one-fourth-block-no-last one-fourth-block-no-first">

    <div class="image-div">
      <Qimage name="gesa.png"/>
    </div>

    <Small :text="$t('home.slide09.text3')"/>

  </div>

  <div class="one-fourth-block one-fourth-block-no-first">

    <div class="image-div">
      <Qimage name="barbastro.png"/>
    </div>

    <Small :text="$t('home.slide09.text4')"/>

  </div>

</div>

</template>

<script>
import Small from '../general/texts/Small.vue'
import Qimage from '../general/elements/Qimage.vue'

export default {
  name: 'Slide09',
  components: {
    Small,
    Qimage
  }
}
</script>

<style lang="scss" scoped>
div {
  text-align: center;
  vertical-align: baseline;

  .image-div {
    height: -webkit-fit-content;
    height: -moz-fit-content;
    height: fit-content;

    img {
      width: 40%;
      margin: auto;
      padding: 5%;
    }
  }
}

@media (max-width: 900px), (max-device-width: 900px) {
  div {
    .image-div {
      img {
        width: 80%;
      }
    }
  }
}

@media (max-width: 750px), (max-device-width: 750px) {
  div {
    .image-div {
      img {
        width: 40%;
      }
    }
  }
}
</style>
